import { render, staticRenderFns } from "./Friend.vue?vue&type=template&id=2c08db7a&scoped=true"
import script from "./Friend.vue?vue&type=script&lang=js"
export * from "./Friend.vue?vue&type=script&lang=js"
import style0 from "./Friend.vue?vue&type=style&index=0&id=2c08db7a&prod&scoped=true&lang=css"
import style1 from "./Friend.vue?vue&type=style&index=1&id=2c08db7a&prod&lang=scss&scoped=true"
import style2 from "./Friend.vue?vue&type=style&index=2&id=2c08db7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08db7a",
  null
  
)

export default component.exports